import {
  REQUEST as req,
  RESPONSE as res,
  FAILURE as fail,
  CLEAR as clr,
  RERUN_REQUEST as rerunReq,
  RERUN_RESPONSE as rerunRes,
  RERUN_FAILURE as rerunFail,
} from '../../actions/discovery/studioForecast';

const initialState = {
  response: null,
  isLoading: false,
  rerunLoading: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:
      return { ...state, isLoading: true, error: null };
    case res:
      return { ...state, isLoading: false, response: action.payload };
    case fail:
      return { ...state, isLoading: false, error: action.payload };
    case rerunReq:
      return { ...state, rerunLoading: true, error: null };
    case rerunRes:
      return { ...state, rerunLoading: false, response: action.payload };
    case rerunFail:
      return { ...state, rerunLoading: false, error: action.payload };
    case clr:
      return { ...initialState };
    default:
      return state;
  }
};
